var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9261 13.7588H37.21C38.2068 13.7588 39.1627 14.1548 39.8676 14.8596C40.5724 15.5644 40.9684 16.5204 40.9684 17.5172V37.145C40.9684 37.6385 40.8712 38.1273 40.6823 38.5833C40.4934 39.0393 40.2166 39.4536 39.8676 39.8026C39.5186 40.1516 39.1043 40.4284 38.6483 40.6173C38.1923 40.8062 37.7035 40.9034 37.21 40.9034H4.7899C4.29634 40.9034 3.80761 40.8062 3.35162 40.6173C2.89563 40.4284 2.48131 40.1516 2.13231 39.8026C1.7833 39.4536 1.50646 39.0393 1.31758 38.5833C1.12871 38.1273 1.03149 37.6385 1.03149 37.145V17.5172C1.03149 16.5204 1.42747 15.5644 2.13231 14.8596C2.83715 14.1548 3.79311 13.7588 4.7899 13.7588H7.92976",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3267 40.9033H18.6733V50.0162H23.3267V40.9033Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3738 50.0161H28.6265",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5014 15.2155C27.2849 15.2181 27.0747 15.1426 26.9093 15.0028C26.7438 14.8631 26.6343 14.6684 26.6006 14.4545C26.4168 13.1328 25.7611 11.9221 24.7546 11.046C23.748 10.1698 22.4586 9.68713 21.1241 9.68713C19.7897 9.68713 18.5002 10.1698 17.4937 11.046C16.4872 11.9221 15.8315 13.1328 15.6476 14.4545C15.614 14.6684 15.5044 14.8631 15.339 15.0028C15.1736 15.1426 14.9634 15.2181 14.7469 15.2155H9.39256C9.15015 15.2155 8.91766 15.1192 8.74625 14.9478C8.57483 14.7764 8.47852 14.544 8.47852 14.3015V12.8838C8.47851 12.7622 8.50276 12.6419 8.54983 12.5298C8.59691 12.4177 8.66587 12.3162 8.75267 12.2311C8.83948 12.146 8.94239 12.079 9.05538 12.0342C9.16836 11.9894 9.28916 11.9675 9.4107 11.9699L11.3828 12.0091C11.5659 12.0127 11.7458 11.9613 11.8993 11.8615C12.0528 11.7616 12.1728 11.618 12.2437 11.4492L12.763 10.2126C12.8292 10.055 12.8499 9.88191 12.8227 9.71311C12.7954 9.5443 12.7214 9.38652 12.609 9.25769L11.3269 7.78869C11.1705 7.60944 11.0901 7.37627 11.1028 7.13871C11.1156 6.90115 11.2205 6.67792 11.3952 6.51645L13.214 4.83542C13.3809 4.68111 13.5994 4.59456 13.8268 4.59266C14.0541 4.59077 14.274 4.67367 14.4435 4.82517L15.9762 6.19514C16.118 6.32186 16.2958 6.40121 16.4848 6.42213C16.6738 6.44306 16.8646 6.40451 17.0306 6.31186L18.1996 5.65969C18.3445 5.57885 18.4647 5.4601 18.5472 5.31617C18.6298 5.17225 18.6716 5.00857 18.6681 4.84269L18.6286 2.91669C18.6261 2.7951 18.6479 2.67424 18.6927 2.56118C18.7375 2.44812 18.8044 2.34514 18.8895 2.25826C18.9746 2.17139 19.0762 2.10238 19.1883 2.05526C19.3004 2.00815 19.4208 1.98388 19.5424 1.98389H22.4869C22.7282 1.98389 22.9598 2.07934 23.131 2.24941C23.3022 2.41948 23.3993 2.65037 23.4009 2.8917L23.4145 4.89741C23.4156 5.05689 23.4584 5.21331 23.5386 5.35113C23.6189 5.48895 23.7338 5.60337 23.8719 5.68304L24.8974 6.27437C25.0646 6.37073 25.2579 6.41175 25.4497 6.39156C25.6416 6.37136 25.8221 6.29099 25.9655 6.16194L27.3979 4.87276C27.5715 4.71655 27.7982 4.63269 28.0316 4.63839C28.2651 4.64408 28.4874 4.73889 28.6532 4.90336L30.4772 6.71349C30.6443 6.87931 30.741 7.10322 30.7471 7.33857C30.7532 7.57391 30.6683 7.80253 30.51 7.9768L29.197 9.42244C29.0756 9.5561 28.9965 9.72272 28.9697 9.90128C28.9429 10.0798 28.9696 10.2623 29.0464 10.4258L29.6408 11.6904C29.7137 11.8456 29.8289 11.9772 29.9731 12.07C30.1173 12.1629 30.2847 12.2133 30.4562 12.2155L32.6001 12.2432C32.8404 12.2463 33.0699 12.344 33.2387 12.515C33.4076 12.6861 33.5023 12.9168 33.5023 13.1572V14.3015C33.5023 14.4216 33.4786 14.5404 33.4327 14.6513C33.3868 14.7622 33.3194 14.863 33.2346 14.9478C33.1497 15.0327 33.0489 15.1 32.938 15.146C32.8271 15.1919 32.7083 15.2155 32.5883 15.2155H27.5014Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1154 31.828C22.324 31.828 23.3038 30.8482 23.3038 29.6396C23.3038 28.431 22.324 27.4512 21.1154 27.4512C19.9068 27.4512 18.927 28.431 18.927 29.6396C18.927 30.8482 19.9068 31.828 21.1154 31.828Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1155 16.0981V27.4513",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1528 28.2049C29.3614 28.2049 30.3412 27.2252 30.3412 26.0165C30.3412 24.8079 29.3614 23.8281 28.1528 23.8281C26.9441 23.8281 25.9644 24.8079 25.9644 26.0165C25.9644 27.2252 26.9441 28.2049 28.1528 28.2049Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4099 16.0981V20.6501L26.7554 24.0346",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6367 23.5848C33.8453 23.5848 34.8251 22.605 34.8251 21.3964C34.8251 20.1878 33.8453 19.208 32.6367 19.208C31.428 19.208 30.4482 20.1878 30.4482 21.3964C30.4482 22.605 31.428 23.5848 32.6367 23.5848Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3931 16.0981V18.2691L31.0366 19.9126",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8471 28.2049C15.0557 28.2049 16.0355 27.2252 16.0355 26.0165C16.0355 24.8079 15.0557 23.8281 13.8471 23.8281C12.6385 23.8281 11.6587 24.8079 11.6587 26.0165C11.6587 27.2252 12.6385 28.2049 13.8471 28.2049Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5899 16.0981V20.6501L15.2444 24.0346",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36346 23.5848C10.5721 23.5848 11.5519 22.605 11.5519 21.3964C11.5519 20.1878 10.5721 19.208 9.36346 19.208C8.15483 19.208 7.17505 20.1878 7.17505 21.3964C7.17505 22.605 8.15483 23.5848 9.36346 23.5848Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6069 16.0981V18.2691L10.9634 19.9126",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons06);
export default __webpack_public_path__ + "static/media/icons-06.ff945746e8f753065964b35afe2064b4.svg";
export { ForwardRef as ReactComponent };